var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "110px",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    viewBox: "0 0 110 110",
    width: "110px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Multicolor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 54.848,
    r: 55,
    style: {
      fill: "#32BEA6"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87,51.848c0-5.885-3.635-10.913-8.778-12.983C74.146,28.898,67.562,24.848,59.5,24.848    c-7.579,0-14.148,4.319-17.369,10.637c-0.962-0.41-2.02-0.637-3.131-0.637c-4.314,0-7.821,3.417-7.984,7.692    C26.35,44.185,23,48.62,23,53.848c0,6.627,5.373,12,12,12h40C75,65.848,87,63.622,87,51.848z",
    style: {
      fill: "#F0F1F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,24.848c-7.579,0-14.148,4.319-17.369,10.637c-5.125-2.183-10.902,1.442-11.116,7.055    C26.35,44.185,23,48.62,23,53.848c0,6.293,4.847,11.446,11.011,11.95l37.095-37.096C67.775,26.044,63.856,24.848,59.5,24.848z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5,83.181c0,2.025,1.642,3.667,3.667,3.667h25.667c2.025,0,3.667-1.642,3.667-3.667V64.848    c0-2.025-1.642-3.667-3.667-3.667H42.167c-2.025,0-3.667,1.642-3.667,3.667V83.181z",
    style: {
      fill: "#FACB1B"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.917,61.181h-5.5v-6.417c0-3.538-2.878-6.417-6.417-6.417s-6.417,2.878-6.417,6.417v6.417h-5.5     v-6.417c0-6.571,5.346-11.917,11.917-11.917s11.917,5.346,11.917,11.917V61.181z",
    style: {
      fill: "#818284"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.509,69.769c0-1.705-1.383-3.088-3.088-3.088s-3.088,1.383-3.088,3.088    c0,1.187,0.678,2.206,1.661,2.723l-1.661,8.856h6.175l-1.661-8.856C56.831,71.975,57.509,70.956,57.509,69.769z",
    style: {
      fill: "#692E19"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudLocked);
export default __webpack_public_path__ + "static/media/cloud_locked.fe921763.svg";
export { ForwardRef as ReactComponent };